import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  // Handle scroll events to collapse nav
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  // Check if current path is a product page
  const isProductPage = ['/cordyceps', '/turkey-tail', '/lions-mane', '/reishi', '/chaga', '/shiitake'].includes(location.pathname);
  return <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'py-2 bg-white/90 backdrop-blur-md shadow-sm' : 'py-4 bg-transparent'}`} data-id="element-29">
      <div className="container mx-auto px-4 md:px-8" data-id="element-30">
        <nav className="flex items-center justify-between" data-id="element-31">
          {/* Logo */}
          <Link to="/" className="text-xl font-semibold" data-id="element-32">
            SPORA
          </Link>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-33">
            <Link to="/" className="text-sm font-medium hover:opacity-70 transition-opacity" data-id="element-34">
              Home
            </Link>
            <Link to="/how-it-works" className="text-sm font-medium hover:opacity-70 transition-opacity" data-id="element-35">
              How It Works
            </Link>
            <Link to="/third-liquid-culture" className="text-sm font-medium hover:opacity-70 transition-opacity" data-id="element-36">
              Third Liquid Culture™
            </Link>
            <Link to="/faq" className="text-sm font-medium hover:opacity-70 transition-opacity" data-id="element-37">
              FAQ
            </Link>
          </div>
          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-38">
            <div className={`w-6 h-0.5 bg-black mb-1.5 transition-all ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`} data-id="element-39"></div>
            <div className={`w-6 h-0.5 bg-black mb-1.5 transition-all ${isMenuOpen ? 'opacity-0' : ''}`} data-id="element-40"></div>
            <div className={`w-6 h-0.5 bg-black transition-all ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`} data-id="element-41"></div>
          </button>
        </nav>
        {/* Mobile Menu */}
        {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md p-4 flex flex-col space-y-4" data-id="element-42">
            <Link to="/" className="text-sm font-medium" data-id="element-43">
              Home
            </Link>
            <Link to="/how-it-works" className="text-sm font-medium" data-id="element-44">
              How It Works
            </Link>
            <Link to="/third-liquid-culture" className="text-sm font-medium" data-id="element-45">
              Third Liquid Culture™
            </Link>
            <Link to="/faq" className="text-sm font-medium" data-id="element-46">
              FAQ
            </Link>
          </div>}
        {/* Product Pill Switcher */}
        {isProductPage && <div className="overflow-x-auto scrollbar-hide mt-4" data-id="element-47">
            <div className="flex space-x-2 justify-center py-2" data-id="element-48">
              <Link to="/cordyceps" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/cordyceps' ? 'bg-red-500 text-white' : 'bg-gray-100'}`} data-id="element-49">
                Cordyceps
              </Link>
              <Link to="/turkey-tail" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/turkey-tail' ? 'bg-orange-500 text-white' : 'bg-gray-100'}`} data-id="element-50">
                Turkey Tail
              </Link>
              <Link to="/lions-mane" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/lions-mane' ? 'bg-yellow-500 text-white' : 'bg-gray-100'}`} data-id="element-51">
                Lion's Mane
              </Link>
              <Link to="/reishi" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/reishi' ? 'bg-green-500 text-white' : 'bg-gray-100'}`} data-id="element-52">
                Reishi
              </Link>
              <Link to="/chaga" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/chaga' ? 'bg-blue-500 text-white' : 'bg-gray-100'}`} data-id="element-53">
                Chaga
              </Link>
              <Link to="/shiitake" className={`px-4 py-1.5 text-xs rounded-full whitespace-nowrap transition-colors ${location.pathname === '/shiitake' ? 'bg-purple-500 text-white' : 'bg-gray-100'}`} data-id="element-54">
                Shiitake
              </Link>
            </div>
          </div>}
      </div>
    </header>;
};
export default Navigation;